<x-shop-notification [notification]="notification$ | async"></x-shop-notification>
<x-shop-livestream></x-shop-livestream>
<ng-content select="x-header-layout"></ng-content>
<ng-content select="x-main-menu"></ng-content>
